import { FlexBetween, FlexRow } from "components/flex-box";
import { Span } from "components/Typography";
import Button from "@mui/material/Button";
import BackspaceOutlinedIcon from "@mui/icons-material/BackspaceOutlined";

import { useAppDispatch } from "hooks/use-app-dispatch";
import { useAppSelector } from "hooks/use-app-selector";
import modules from "modules";

const { actions: pcBuilderActions, selectors: pcBuilderSelectors } =
  modules.pcBuilder;

const RowLabel = () => {
  const dispatch = useAppDispatch();
  const isEmptyBuildParts = useAppSelector(
    pcBuilderSelectors.selectIsEmptyBuildParts
  );

  const onClickClearAll = () => {
    dispatch(pcBuilderActions.clearBuildParts());
  };

  return (
    <FlexRow flex={1} py={1} borderBottom="1px solid #AEB4BE">
      <Span flex={1} color="grey.800" fontSize={18} textAlign="center">
        {"Component"}
      </Span>
      <Span flex={1.6} color="grey.800" fontSize={18} textAlign="center">
        {"Product"}
      </Span>
      <Span flex={2} color="grey.800" fontSize={18}>
        {"Details"}
      </Span>
      <FlexBetween flex={2} pr={2} bgcolor="">
        <Span color="grey.800" fontSize={18}>
          {"Price"}
        </Span>
        {isEmptyBuildParts ? null : (
          <Button
            variant="outlined"
            color="primary"
            startIcon={<BackspaceOutlinedIcon />}
            onClick={onClickClearAll}
          >
            Clear All
          </Button>
        )}
      </FlexBetween>
    </FlexRow>
  );
};

export default RowLabel;
